import type { DiscoveredRouteModule } from '@/router/generator/types';

// Local constants
const DonateView = () => import('@/views/DonateView.vue');
export const NAME_DONATE = 'Donate';
export const PATH_DONATE = 'donate';

export const route: DiscoveredRouteModule = {
  id: 'app.payments.donate',
  scope: 'app',
  moduleKey: 'payments',
  name: NAME_DONATE,
  path: PATH_DONATE,
  component: DonateView,
  meta: {
    dataLoaders: ['project_document', 'demo_data', 'features', 'payments_base']
  },
  requiresFeature: 'payments.donations',
};


